<script setup lang="ts">
import { BaseButton } from '@magma-app/magma-lapilli';

defineProps<{
  buttonText: string;
  disabled: boolean;
  showTerms: boolean;
}>();

const emit = defineEmits<{
  (event: 'primary'): void;
}>();
</script>

<template>
  <div
    class="gradient__white__01 sticky bottom-0 mx-auto max-w-4xl bg-background-default px-4 pb-4 pt-8"
  >
    <BaseButton
      class="mb-3 w-full"
      :text="buttonText"
      data-cy="signup-helper-complete"
      size="md"
      :disabled="disabled"
      @click="emit('primary')"
    />

    <div
      v-if="showTerms"
      class="text-center text-mgm-txt-xs font-normal text-foreground-default"
    >
      {{ $t('generic.termsAndPrivacy.part1') }}
      <a
        class="font-medium text-foreground-brand-default"
        href="https://www.magma.app/legals/helpers-terms-of-use"
        target="_blank"
      >
        {{ $t('generic.termsAndPrivacy.part2') }}
      </a>
      {{ $t('generic.termsAndPrivacy.part3') }}
      <a
        class="font-medium text-foreground-brand-default"
        href="https://www.magma.app/legals/privacy-policy"
        target="_blank"
      >
        {{ $t('generic.termsAndPrivacy.part4') }}
      </a>
    </div>
  </div>
</template>
